import React,{ useContext } from 'react';
import SimpleContext from './../../context/SimpleContext';
import SabadKharidDrawer from './../SabadKharidDrawer/SabadKharidDrawer';
import NumberFormat from 'react-number-format';
import config from './../../../services//config.json';
import Counter from '../counter/Counter';


const SingleProducts2 = () => {

    const context = useContext(SimpleContext);

    

    return ( 
        <div className='products'>
            <div className="otherPagesHeader">
                <div onClick={context.drawerToggleClickHandler} className="barbuttonn">
                    <i className="fa fa-bars" />
                </div>
                <div className="headersNames">
                    <h6>محصولات</h6>
                </div>
                <div className="searchbtnn">
                    <i className="fa fa-filter" />
                </div>
            </div>
            <div className="productHolder">
                {
                    context.SinglePrdCategory2.length ? 
                    context.SinglePrdCategory2.map((pr,i) =>

                    <div className="card" key = {i}>
                        <div className="card-image-place" onClick={()=>context.handleShowSimpleProduct(pr.slug, pr.stock, pr.number_in_sale)}>
                        
                        <img  
                            className="card-img-top"
                            src={`${config.AndroidProductsPictures}/${pr.slug}.jpg`} 
                            alt=""
                        />
                        
                        
                        {
                            pr.stock===0 || pr.stock===pr.number_in_sale?
                            <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"notavailable.png"}`} alt=""/>
                            :
                            pr.sahmie_bandi !== 0 ?
                            <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"sahmiyeh.png"}`} alt=""/>
                            :
                            <img className="card-img-mini_UL img-thumbnail" src={`${config.DiscountImage}/${pr.ULImg}`} alt=""/>
                            } 
                    
                            <img className="card-img-mini_UR img-thumbnail" src={`${config.DiscountImage}/${pr.URImg}`} alt=""/>
                            <img className="card-img-mini_DL img-thumbnail" src={`${config.DiscountImage}/${pr.DLImg}`} alt=""/>
                            <img className="card-img-mini_DR img-thumbnail" src={`${config.DiscountImage}/${pr.DRImg}`} alt=""/>
                        {/* <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"tamamshod.png"}`} alt=""/> */}
                        
                        </div>
                        
                        <div className="card-body" onClick={()=>context.handleShowSimpleProduct(pr.slug, pr.stock, pr.number_in_sale)}>
                            <div className="cardtxt">
                            <p className="card-text">{pr.name}<br/><br/>
                            قیمت پایه<br/>
                            <NumberFormat value={pr.price} displayType={'text'} thousandSeparator={true} /> ريال<br/><br/>
                            قیمت مصرف کننده<br/>
                            <NumberFormat value={pr.user_price} displayType={'text'} thousandSeparator={true} /> ريال
                            </p>
                            </div>
                        </div>
                    
                        <Counter min={pr.minimum} max={pr.maximum} unit={pr.unit} numUnit={pr.number_in_unit}/>
                        
                  </div>
                    ):null
                }
            </div>
            <div className="SabadDrawer" >
                <SabadKharidDrawer/>
            </div>
        </div> 
     );
}
 
export default SingleProducts2;